module.exports = __webpack_public_path__ + "img/empty_bg.4439d75f.jpg";